import { render, staticRenderFns } from "./index.vue?vue&type=template&id=4ffb4795&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=4ffb4795&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ffb4795",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/centurygame/web-vip/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4ffb4795')) {
      api.createRecord('4ffb4795', component.options)
    } else {
      api.reload('4ffb4795', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=4ffb4795&scoped=true", function () {
      api.rerender('4ffb4795', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "packages/components/src/componentsUI/toast/index.vue"
export default component.exports